import { Group, Tooltip } from '@mantine/core';
import { IconArrowUpLeft } from '@tabler/icons-react';
import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import P2Medium from 'components/typography/P2Medium';

/**
 * Column for the type.
 */
export default function TypeColumn({
  data: { type, inheritedFromDeviceName, isInheritedFromParent },
}: {
  data: RevisionPlanRow;
}) {
  return (
    <Group spacing={6} noWrap>
      {isInheritedFromParent && (
        <Tooltip
          label={`Úkon je zdedený z nadradeného zariadenia${
            inheritedFromDeviceName ? ` (${inheritedFromDeviceName})` : ''
          }.`}
          openDelay={200}
          withinPortal
        >
          <IconArrowUpLeft size={16} stroke={1.8} />
        </Tooltip>
      )}
      <P2Medium color="gray.8">{type}</P2Medium>
    </Group>
  );
}
